import { css, type SxProps, styled, type Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

const noop = () => undefined;
const sharedLinkStyles = (theme: Theme, isDisabled: boolean) => css`
  color: ${theme.palette.primary.main}; 
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 28px;
  padding: 0px;
  text-transform: none;

  ${
    isDisabled &&
    css`
    color: ${theme.palette.text.secondary};
    pointer-events: none;
  `
  }
`;
const StyledOutsideLink = styled('a')<{ isDisabled: boolean }>`
  ${({ theme, isDisabled }) => sharedLinkStyles(theme, isDisabled)}
`;

interface LinkProps {
  to: string;
  children: ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
  ['data-test']?: string;
}

interface OutsideLinkProps extends LinkProps {
  openInNewTab?: boolean;
  sx?: SxProps<Theme>;
}

export const OutsideLink = (props: OutsideLinkProps) => {
  const { to, children, onClick, isDisabled = false, openInNewTab = false, sx } = props;
  const dataTest = props['data-test'] || 'page-link';

  return (
    <StyledOutsideLink
      isDisabled={isDisabled}
      onClick={onClick ?? noop}
      href={to}
      target={openInNewTab ? '_blank' : '_self'}
      data-test={dataTest}
      rel="noreferrer"
      sx={sx}
    >
      {children}
    </StyledOutsideLink>
  );
};
